<template>
  <v-layout row wrap>
      <!-- <v-flex d-flex :class="`lg${horizontal?6:12}`">
          <Tramite :tramite="juramento">
          <template slot="accionesTramite">
             <v-btn color="primary" to="/juramento" small>IR a LISTA</v-btn>
              <v-btn color="primary lighten-3" small @click="verGaleriaJuramento">fotos</v-btn>
          </template>
      </Tramite>
      </v-flex> -->
       <v-flex d-flex :class="`lg${horizontal?6:12}`">
          <Tramite :tramite="inhabilitados">
          <template slot="accionesTramite">
             <Fallecido />
          </template>
      </Tramite>
      </v-flex>
       <Galeria :dialog="dialogGaleria" :juramentos="galeriaJuramento" @cerrarGaleria="dialogGaleria=false"/>
  </v-layout>
</template>
<script>
import Fallecido from "@/components/Fallecidos";
import Galeria from "@/components/Juramento/GaleriaFotos";
import Tramite from "@/components/Inicio/Tramite";
export default {
    components:{
        Tramite,Fallecido,Galeria
    },
    props:{
        horizontal:{
            type:Boolean,
            default:false
        }
    },
  data() {
    return {
      juramento:{
          titulo:'JURAMENTOS',
          descripcion:'Lista de Juramentos Realizados a Nivel Nacional',
          imagen:'https://apirpa2.justicia.gob.bo/pagina/varios/0032.jpg',
          acciones:true,
      },
      inhabilitados:{
          titulo:'MATRÍCULAS INHABILITADAS POR FALLECIMIENTO',
          descripcion:'Presione el botón para ver las matículas inhabilitadas de abogadas y abogados por fallecimiento.',
          // imagen:'https://apirpa2.justicia.gob.bo/pagina/varios/credencialInhabilitada.png',
          imagen:require('@/assets/fallecido.png'),
          acciones:true
      },  
      galeriaJuramento: [],
      dialogGaleria: false
    };
  },
  methods: {
    verGaleriaJuramento() {
      this.galeriaJuramento = this.$store.getters.juramentoConFotos;
      this.dialogGaleria = true;
    }
  }
};
</script>


// WEBPACK FOOTER //
// src/components/Inicio/Extra.vue